import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { DataService } from '../data.service';
import { AllTransferStatusModel } from '../model/all-transfer-status-model';
import { ConnectionKey } from '../model/connection-key';
import { FileObjectList, FileObjectsModel } from '../model/file-objects-model';
import { HeartBeatResponse } from '../model/heart-beat-response';
import { TransferArrayModel } from '../model/transfer-array-model';
import { TransferFilesRequestModel } from '../model/transfer-files-request-model';
import { URLParams } from '../model/urlparams';
import { UserDetailsModel } from '../model/user-details-model';

@Injectable({
  providedIn: 'root'
})
export class FileCatalystAPIService {

  fcAPIs = environment.fileCatalystApis;

  constructor(private http:HttpClient,private dataService:DataService) { }

  queryFCLocal(path:string)
  {
    console.log('Query FC Local ',this.fcAPIs.localResource.getRequest+path)
    return this.http.get<FileObjectsModel>(this.fcAPIs.localResource.getRequest+path).pipe(retry(3))
  }

 


  getFCUploadConnection(){
    const body = {
      "MungedConnectionRequest" : this.dataService.getUploadPGPMessage(),
      "Key" : "key"
    }

    let headers = new HttpHeaders();
    return this.http.post<ConnectionKey>(this.fcAPIs.connectResource.postRequest,body,{headers:headers});
  }

  getFCDownloadConnection(){
    const body = {
      "MungedConnectionRequest" : this.dataService.getDownloadPGPMessage(),
      "Key" : "key"
    }

    let headers = new HttpHeaders();
    return this.http.post<ConnectionKey>(this.fcAPIs.connectResource.postRequest,body,{headers:headers});
  }

  getTransferStatus(jobId:String)
  {
    return this.http.get<AllTransferStatusModel>(this.fcAPIs.statusResource.getRequest+jobId);
  }

  getAllTransferStatus(){

    // the response is not an array, its basically an object which has all transfers value, which is the array of all status transfer model

    return this.http.get<TransferArrayModel>(this.fcAPIs.statusResource.getRequest);

  }

  initiateFCUploadTransfer(destination:String,fileList:String[])
  {

    let urlParams:URLParams = this.dataService.getUrlParams();
   
    let headers= new HttpHeaders()
    // headers.set('fileName',files[0].name)
    // headers.set('Access-Control-Allow-Origin', 'http://localhost:4200');
    // headers.set('Access-Control-Allow-Methods','GET,HEAD,OPTIONS,POST,PUT');
    // headers.set('Access-Control-Allow-Headers','Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers');
    // headers.set('Content-Type', 'multipart/form-data');
    // headers.set('Access-Control-Allow-Credentials','true');
    // console.log('Headers ',headers)
   

   
    const body = 
    {
      "DestinationConnectionKey":destination,
      "SourceConnectionKey":"local",
      "fileList":fileList,
      "transferConfiguration":{
        "AutoResume" : true,
        "MaxRetries" : 3,
        "NumBlockReaders" : 1,
        "NumBlockWriters" : 1,
        "NumberOfClients" : 1,
        "NumThreads" : 3,
        "OptimizeBlockSize" : true,
        "PacketQueueDepth" : 1000,
        "PacketSize" : 1024,
        "VerifyIntegrity" : true,
        "VerifyMode":0,
        // "Mode":4,
        "StartRate":1000,
        "TargetRate":100000,
        "RemoteDirectory" :urlParams.userName+"/"+urlParams.partNumber+"/",
        "OverwriteOption": 'YES_TO_ALL'
        
        // "UseCompression":true
      }
        
    }
    
   
    console.log("body ",body)

    return this.http.post<TransferFilesRequestModel>("http://127.0.0.1:12680/rs/files/transferRev1",body,{headers:headers});    // console.log(typeof(obs));

  }




  initiateFCDownloadTransfer(source:String,fileList:String[])
  {

    let urlParams:URLParams = this.dataService.getUrlParams();
   
    let headers= new HttpHeaders()
    // headers.set('fileName',files[0].name)
    // headers.set('Access-Control-Allow-Origin', 'http://localhost:4200');
    // headers.set('Access-Control-Allow-Methods','GET,HEAD,OPTIONS,POST,PUT');
    // headers.set('Access-Control-Allow-Headers','Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers');
    // headers.set('Content-Type', 'multipart/form-data');
    // headers.set('Access-Control-Allow-Credentials','true');
    // console.log('Headers ',headers)
    const body = 
    {
      "DestinationConnectionKey":"local",
      "SourceConnectionKey":source,
      "fileList":fileList,
      "transferConfiguration":{
        "AutoResume" : true,
        "MaxRetries" : 3,
        "NumBlockReaders" : 2,
        "NumBlockWriters" : 2,
        "NumberOfClients" : 1,
        "NumThreads" : 3,
        "OptimizeBlockSize" : true,
        "PacketQueueDepth" : 1000,
        "PacketSize" : 1024,
        "VerifyIntegrity" : true,
        "VerifyMode":0,
        // "Mode":4,
        "StartRate":1000,
        "TargetRate":100000,
        "OverwriteOption": 'YES_TO_ALL'
        
        // "UseCompression":true
      }
        
    }
    
   
    console.log("body ",body)

    return this.http.post<TransferFilesRequestModel>("http://127.0.0.1:12680/rs/files/transferRev1",body,{headers:headers});    // console.log(typeof(obs));

  }

  //prod


  // initiateFCDownloadTransfer(source:String,fileList:String[])
  // {

  //   let urlParams:URLParams = this.dataService.getUrlParams();
   
  //   let headers= new HttpHeaders()
  //   // headers.set('fileName',files[0].name)
  //   // headers.set('Access-Control-Allow-Origin', 'http://localhost:4200');
  //   // headers.set('Access-Control-Allow-Methods','GET,HEAD,OPTIONS,POST,PUT');
  //   // headers.set('Access-Control-Allow-Headers','Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers');
  //   // headers.set('Content-Type', 'multipart/form-data');
  //   // headers.set('Access-Control-Allow-Credentials','true');
  //   // console.log('Headers ',headers)
  //   const body = 
  //   {
  //     "DestinationConnectionKey":"local",
  //     "SourceConnectionKey":source,
  //     "fileList":fileList,
  //     "transferConfiguration":{
  //       "AutoResume" : true,
  //       "MaxRetries" : 3,
  //       "NumBlockReaders" : 1,
  //       "NumBlockWriters" : 1,
  //       "NumberOfClients" : 1,
  //       "NumThreads" : 2,
  //       "OptimizeBlockSize" : true,
  //       "PacketQueueDepth" : 1000,
  //       "PacketSize" : 2048,
  //       // "Mode":1,
  //       "StartRate":1000,
  //       "TargetRate":100000
        
        
  //       // "UseCompression":true
  //     }
        
  //   }
    
   
  //   console.log("body ",body)

  //   return this.http.post<TransferFilesRequestModel>("http://127.0.0.1:12680/rs/files/transferRev1",body,{headers:headers});    // console.log(typeof(obs));

  // }
  getTransferAgentHeartBeat()
  {
    console.log('getTransferAgentHeartBeat ')
    return this.http.get<HeartBeatResponse>(this.fcAPIs.heartBeatResource.getRequest).pipe(retry(3));
  }

  getRemoteFiles(directory:string,connectionKey:string)
  {
    return this.http.get<FileObjectsModel>(this.fcAPIs.remoteResource.getRequest+directory,{params:{connectionKey:connectionKey}})
  }

  getRemoteFile(fileName:string, directory:string,connectionKey:string){
    return this.http.get<FileObjectList>(this.fcAPIs.remoteFilesResource.getRequest+fileName,{params:{connectionKey:connectionKey,file:directory}});
  }


  // checkTAStatus()
  // {
  //   console.log('In check')
  //   let statusIntvSubc : Subscription;
  //   let statusInterval = interval(2000);
    
  //   statusIntvSubc = statusInterval.subscribe(() => {
  //    this.getTransferAgentHeartBeat().subscribe(
  //       (response)=> {
  //         console.log('response from heart beat service ',response)
  //         if(response.status != "OK")
  //         {
  //          this.openTAModal();
  //          // Installed, but not turned on
  //          // Not installed
  //         }else
  //         {
  //           statusIntvSubc.unsubscribe();
  //           this.closeTAModal();
            
  //         }
  //       },
  //       (error)=>
  //       { console.log('error from heart beat service ',error)

  //         this.openTAModal();
  //         // console.log('error from heart beat service ',error)
  //         // let flag = this.dataService.getToggleValue()
  //         // if(error.status != "OK" && flag==true)
  //         // {
  //         //   this.openTAModal();
  //         // }else
  //         // {
  //         //   this.closeTAModal();
  //         // }
  
  //       }
  //     )
  //   })
    
  // }

  openTAModal(){
    console.log('Opening TA Modal')
    let btn = document.getElementById("downloadUtility");
    btn.click();
  }

  closeTAModal(){
    console.log('Closing TA Modal')
    let clsBtn = document.getElementById("closeModal");
    clsBtn.click();
  }

  getUserDetails(connectionKey:string){
    return this.http.get<UserDetailsModel>(this.fcAPIs.userDetailsResource.getRequest,{params:{connectionKey:connectionKey}});
  }

  

  
}
